// providers/wealthbox.ts
import * as Api from '@ViewModels';
import { provider, toggle } from './helpers';

export const wealthboxConfig = provider(Api.IntegrationProvider.Wealthbox, {
	displayName: 'Wealthbox',

	main: {
		writebacks: true,
		fields: [
			toggle('preferNicknameAsFirstName', {
				label: 'Prefer Nickname as First Name',
				subtitle: 'Use the contact nickname from Wealthbox as the first name in Levitate',
			}),
			toggle('prospectsEnabled', {
				label: 'Sync Prospects',
				subtitle: 'Whether to sync Wealthbox prospects as contacts in Levitate',
			}),
		],
	},

	keyFacts: {
		birthdayDisplay: true,
		customDateFields: true,
	},

	tags: {
		coreTags: true,
		customFields: true,
	},
});
